import { NavLink } from 'react-router-dom';
import './Navbar.css'; // Import the CSS file

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <NavLink exact="true" to="/" className="nav-link" activeClassName="active-link">
          Home
        </NavLink>
        <NavLink to="/about" className="nav-link" activeClassName="active-link">
          About
        </NavLink>
        <NavLink to="/courses" className="nav-link" activeClassName="active-link">
          Courses
        </NavLink>
        <NavLink to="/contact" className="nav-link" activeClassName="active-link">
          Contact
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
